/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/jsx-no-bind */
import { HomeOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Image, Switch } from 'antd';
import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { Field, Formik } from 'formik';
import { toast } from 'react-toastify';
import { BoxForm, BoxInput, ButtonContainer, Container } from './styles';
import { PageTitle } from '../../components/PageTitle';
import { api } from '../../services/api';
import { Loading } from '../../components/Loading';

export function TestimonialUpdate() {
  const [initialValues, setInitialValues] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [isShowHome, setIsShowHome] = useState(false);
  const { testimonial_id } = useParams();
  const [testimonialToUpload, setTestimonialToUpload] = useState();
  const [testimonialPreview, setTestimonialPreview] = useState(null);

  const [productCategories, setProductCategories] = useState(null);
  const [productCategoriesSelected, setProductCategoriesSelected] = useState(
    [],
  );

  async function updateTestimonials(values) {
    setButtonLoading(true);
    try {
      const formData = new FormData();

      if (testimonialToUpload) {
        formData.append('file', testimonialToUpload, testimonialToUpload.name);
      }

      const { name, text, video_url } = values;

      formData.append('name', name);
      formData.append('text', text);
      formData.append('is_show_home', isShowHome);
      formData.append(
        'product_category_ids',
        productCategoriesSelected.join(','),
      );
      if (video_url) {
        formData.append('video_url', video_url);
      }

      await api.put(`/testimonials/${testimonial_id}`, formData);

      toast.success('Depoimento cadastrado com sucesso');

      setButtonLoading(false);
      navigate(-1);
    } catch (err) {
      toast.error('Erro ao cadastrar depoimento');
      setButtonLoading(false);
    }
  }

  async function loadTestimonial() {
    try {
      const response = await api.get(`/testimonials/show/${testimonial_id}`);

      setInitialValues(response.data);
      setIsShowHome(response.data.is_show_home);
      setTestimonialPreview(response.data.photo_url);
      setProductCategoriesSelected(
        response.data.productCategoryId
          ? response.data.productCategoryId.split(',')
          : [],
      );
      setLoading(false);
    } catch (err) {
      toast.error('Erro ao carregar depoimento');
      setLoading(false);
    }
  }

  useEffect(() => {
    loadTestimonial();
  }, []);

  function handleTestimonialPhono(event) {
    if (event.target.files) {
      const file = event.target.files[0];
      setTestimonialToUpload(file);

      const reader = new FileReader();

      reader.onload = () => {
        setTestimonialPreview(reader.result);
      };

      if (file) {
        reader.readAsDataURL(file);
      }
    }
  }

  async function loadProductCategories() {
    try {
      const response = await api.get('/products/categories');
      setProductCategories(response.data);
    } catch (error) {
      toast.error('Erro ao carregar categorias');
    }
  }

  useEffect(() => {
    loadProductCategories();
  }, []);

  return (
    <Container>
      <Breadcrumb style={{ marginBottom: 40 }}>
        <Breadcrumb.Item key="/">
          <NavLink to="/">
            <HomeOutlined />
          </NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item key="/depoimentos">
          <NavLink to="/depoimentos">Depoimentos</NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Criação</Breadcrumb.Item>
      </Breadcrumb>

      <PageTitle
        title="Cadastro de usuário"
        description="Gerenciamento de coordenadores e especialistas"
      />

      {!loading && initialValues && (
        <BoxForm>
          <Formik initialValues={initialValues} onSubmit={updateTestimonials}>
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                {testimonialPreview && (
                  <div>
                    <Image width={200} height={200} src={testimonialPreview} />
                  </div>
                )}

                <BoxInput style={{ marginTop: 30 }}>
                  <label htmlFor="photo">Foto</label>
                  <input
                    id="photo"
                    type="file"
                    name="photo"
                    onChange={handleTestimonialPhono}
                  />
                </BoxInput>

                <BoxInput>
                  <label htmlFor="name">Nome</label>
                  <Field id="name" type="text" name="name" placeholder="Nome" />
                </BoxInput>

                <BoxInput>
                  <label htmlFor="video_url">Vídeo URL</label>
                  <Field
                    id="video_url"
                    type="text"
                    name="video_url"
                    placeholder="Vídeo URL"
                  />
                </BoxInput>

                <BoxInput>
                  <label htmlFor="text">Texto</label>
                  <Field name="text">
                    {({ field }) => (
                      <div>
                        <textarea {...field} value={field.value || ''} />
                      </div>
                    )}
                  </Field>
                </BoxInput>

                <BoxInput>
                  <label htmlFor="is_show_home">Mostrar na home</label>
                  <Switch
                    defaultChecked
                    checked={isShowHome}
                    onChange={() => setIsShowHome(!isShowHome)}
                  />
                </BoxInput>

                <BoxInput>
                  <label htmlFor="is_show_home">Categorias</label>
                  <Checkbox.Group
                    defaultValue={productCategoriesSelected}
                    onChange={(checkedValues) =>
                      setProductCategoriesSelected(checkedValues)
                    }
                  >
                    {productCategories &&
                      productCategories.map((categoryItem) => (
                        <Checkbox value={categoryItem.id}>
                          {categoryItem.name}
                        </Checkbox>
                      ))}
                  </Checkbox.Group>
                </BoxInput>

                <ButtonContainer>
                  <Button
                    type="primary"
                    htmlType="submit"
                    size="middle"
                    loading={buttonLoading}
                  >
                    Atualizar depoimento
                  </Button>
                </ButtonContainer>
              </form>
            )}
          </Formik>
        </BoxForm>
      )}

      {loading && <Loading />}
    </Container>
  );
}
